import { useEffect, useState } from 'react';

/**
 * The lookup data UsersTable needs besides the users themselves: roles,
 * departments, centres, venues, modules and the organisation's users.
 */
export default function useUsersTableData({ rolesUrl, placesUrl, modulesUrl, organisationUsersUrl }) {
    const [roles, setRoles] = useState([]);
    const [departments, setDepartments] = useState([]);
    const [costcenters, setCostcenters] = useState([]);
    const [revDepartments, setRevDepartments] = useState([]);
    const [revCostcenters, setRevCostcenters] = useState([]);
    const [venues, setVenues] = useState([]);
    const [organisationUsers, setOrganisationUsers] = useState([]);
    const [modules, setModules] = useState([]);

    useEffect(() => {
        axios
            .get(rolesUrl)
            .then((res) => {
                const { roles } = res.data;
                setRoles(roles);
            })
            .catch((error) => {
                console.log(error);
            });

        axios
            .get(placesUrl)
            .then((res) => {
                const { departments, costcenters, venues, revdepartments, revcostcenters, generalRevDepartments } = res.data;
                const generalRevData = [];
                generalRevDepartments.forEach((item) => {
                    item.id = 'general_' + item.id;
                    generalRevData.push(item);
                });

                setDepartments(departments);
                setCostcenters(costcenters);
                setRevDepartments(generalRevData.concat(revdepartments));
                setRevCostcenters(revcostcenters);
                setVenues(venues);
            })
            .catch((error) => {
                console.log(error);
            });

        axios
            .get(modulesUrl)
            .then((res) => {
                setModules(res.data.modules);
            })
            .catch((error) => {
                console.log(error);
            });

        fetchOrganisationUsers();
    }, []);

    const fetchOrganisationUsers = () => {
        axios
            .get(organisationUsersUrl)
            .then((res) => {
                setOrganisationUsers(res.data.users);
            })
            .catch((error) => {
                console.log(error);
            });
    };

    return {
        roles,
        departments,
        costcenters,
        revDepartments,
        revCostcenters,
        venues,
        organisationUsers,
        fetchOrganisationUsers,
        modules,
    };
}
